import React, { useContext } from 'react';
import { RadioGroup } from '@/common/components/Inputs/index';
import Form from '@/common/components/Form/index';
import { useCurrentDecedentId } from '@/app/providers/DecedentProvider';
import { DetailsContext } from '@/common/containers/TaskDetails/components/DetailsProvider';
import { useSubmitAnswersMutation } from '@/entities/question';

const SingleAnswerForm = ({
  options,
  stepId,
  answers = [],
  isLastTask,
  updateTask,
}) => {
  const decedentId = useCurrentDecedentId();
  const { section } = useContext(DetailsContext);
  const submitAnswersMutation = useSubmitAnswersMutation();

  const onSubmit = async (form) => {
    if (!form[stepId]) return;
    const payload = {
      taskStepId: stepId,
      action: 'create',
      value: form[stepId],
    };
    if (answers.length) {
      payload.answerId = answers[0].id;
    }

    try {
      await submitAnswersMutation.mutateAsync({
        answers: [payload],
        decedentId,
        section,
        sectionType: 'Task',
      });
      await updateTask(true, stepId, isLastTask);
    } catch (err) {
      console.log(err);
    }
  };

  const onFormStateChange = (state, submitForm) => {
    if (state.isDirty) submitForm();
  };

  return (
    <div>
      <Form
        initialValues={answers.length ? { [stepId]: answers[0].value } : {}}
        onSubmit={onSubmit}
        onFormStateChange={onFormStateChange}
      >
        <RadioGroup
          options={options}
          name={`${stepId}`}
          disabled={submitAnswersMutation.isPending}
        />
      </Form>
    </div>
  );
};

export default SingleAnswerForm;
